<template>
  <card-template-v2 class="common-dashboard-card">
    <template #header>
      <div class="flex-row flex__left">
        <span class="margin-right-10">
          <el-badge
            v-if="unreadNotifysCount"
            :value="
              unreadNotifysCount > 9 ? '+9' : `${unreadNotifysCount || 0}`
            "
          >
            <i class="fas fa-bell font-size__larger color__blue"></i>
          </el-badge>
          <i v-else class="fas fa-bell font-size__larger color__blue"></i>
        </span>
        <h3 class="tt1">{{ cardTitle }}</h3>
      </div>
    </template>
    <template #body>
      <VuePerfectScrollbar class="scroll-area">
        <div class="list-notify">
          <div class="block" style="padding: 10px">
            <el-timeline>
              <vb-notification-timeline-item
                v-for="item in notifis"
                :key="item.notificationDetailId"
                :notificationDetail="item"
                @click="
                  ({ notificationDetail }) => viewDetailV2(notificationDetail)
                "
              ></vb-notification-timeline-item>
            </el-timeline>
          </div>
        </div>
      </VuePerfectScrollbar>
    </template>
  </card-template-v2>
</template>

<script>
import convertToLabelFilter from "../../filters/convertToLabelFilter.js";
import constants from "../../constants";
import vbNotificationService from "../../services/vbNotificationService";
import NotificationItemCv from "../../components/header/notification-item-cv";
import NotificationItemVb from "../../components/header/notification-item-vb";
import notificationMixin from "../../mixins/notificationMixin";
import NotificationItemQuahanCv from "../../components/header/notification-item-quahan-cv";
import NotificationItemBanhanhtoi from "../../components/header/notification-item-banhanhtoi";
import NotificationItemRankingScore from "../../components/header/notification-item-ranking-score";
import VbNotificationItem from "./vb-notification-item";
import VbNotificationTimelineItem from "./vb-notification-timeline-item";
import CardTemplateV2 from "../common/layout/card-template-v2";

export default {
  name: "notifications-card-v2",
  mixins: [notificationMixin],
  props: ["cardTitle", "notifis", "notifysCount", "unreadNotifysCount"],
  components: {
    CardTemplateV2,
    VbNotificationTimelineItem,
    VbNotificationItem,
    NotificationItemRankingScore,
    NotificationItemBanhanhtoi,
    NotificationItemQuahanCv,
    NotificationItemVb,
    NotificationItemCv,
    VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
  },
  filters: { convertToLabelFilter },
  data() {
    return {
      MESSAGE_TYPE: constants.VB_NOTIFICATION.MESSAGE_TYPE,
    };
  },

  // computed: {
  //   userDeptRoles() {
  //     return this.$store.getters.userDeptRoles;
  //   }
  // },

  methods: {
    viewDetailV2(item) {
      vbNotificationService.maskAsSeen(item);
      this.$store.commit("updateSeenNotifi", item);
      switch (item.messageType) {
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.CREATE:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.UPDATE:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.PHE_DUYET:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.HUY:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.YCBS:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.DK_DEADLINE:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.GIA_HAN:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.BAO_CAO:
          this.viewHcCommandsDetail(item);
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.CAP_NHAT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.HUY_YEU_CAU:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.TU_CHOI:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.PHE_DUYET:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.DANG_KY:
          this.viewHcDieuXeDetail(item);
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.CAP_NHAT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.HUY_YEU_CAU:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.TU_CHOI:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.PHE_DUYET:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.DANG_KY:
          this.viewHcCaseFlightDetail(item);
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.CAP_NHAT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.HUY_YEU_CAU:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.TU_CHOI:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.PHE_DUYET:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.DANG_KY:
          this.viewHcCaseHotelDetail(item);
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.CAP_NHAT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.HUY_YEU_CAU:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.TU_CHOI:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.PHE_DUYET:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.DANG_KY:
          this.viewHcCasePhongHopDetail(item);
          break;

        case constants.VB_NOTIFICATION.MESSAGE_TYPE.ADDNEWS:
          this.viewNews(item);
          break;
          
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.ADDNOTI:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DELETE_USERNOTI:
          this.viewNotification(item);
          break;

        case constants.VB_NOTIFICATION.MESSAGE_TYPE.TAG_COMMENT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.REPLY_COMMENT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.APPROVE_DISCUSS:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DECLINE_DISCUSS:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DELETE_DISCUSS:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.SEND_APPROVE_DISCUSS:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.REPORT_COMMENT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.ADD_DISCUSS:
          this.viewDiscuss(item);
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DK_PHONGHOP:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.HUY_PHONG_HOP:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH
          .CAP_NHAT_PHONG_HOP:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH
          .PHE_DUYET_PHONG_HOP:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH
          .TU_CHOI_PHONG_HOP:
          this.viewHanhChinhPH(item);
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE.CAP_NHAT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE
          .HUY_YEU_CAU:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE
          .PHE_DUYET:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE.DANG_KY:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE.TU_CHOI:
          this.viewHanhChinhDX(item);
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .CAP_NHAT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .HUY_YEU_CAU:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .PHE_DUYET:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .DANG_KY:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .TU_CHOI:
          this.viewHanhChinhLT(item);
          break;
        default:
          this.viewDetail(item);
      }
    },

    viewDetail(item) {
      if (this.isViewTaskDetail(item)) this.viewTaskDetail(item);
      else if (
        this.isVbNotificationV2(item) ||
        item.messageType ===
          constants.VB_NOTIFICATION.MESSAGE_TYPE.INCOMING_BANHANH ||
        item.messageType === constants.VB_NOTIFICATION.MESSAGE_TYPE.CC_DOC_IN
      ) {
        this.viewDocDetailV2(item);
      } else if (this.isDocument(item)) {
        this.viewDocument(item);
      } else this.viewDocDetail(item);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/dashboard/notifications-card-v2.vue